module.exports = __webpack_public_path__ + "img/flag.5a009e8d.svg";